import SiteEditTable from './SiteEditTable.connect'

export default SiteEditTable
